/**
 * This is entry point for `gatsby-recipes/components`
 */

import StepRenderer from "./components/step-renderer"

console.log(StepRenderer)

export { StepRenderer }
